import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4291016863 from "../../../../../packages/component/src/components/select/demo/demo1.js?loadDemo";
import legacyImportDemo_1914942076 from "../../../../../packages/component/src/components/select/demo/demo2.js?loadDemo";
import legacyImportDemo_2656822749 from "../../../../../packages/component/src/components/select/demo/demo3.js?loadDemo";
import legacyImportDemo_4122151657 from "../../../../../packages/component/src/components/select/demo/demo16.js?loadDemo";
import legacyImportDemo_2899520442 from "../../../../../packages/component/src/components/select/demo/demo4.js?loadDemo";
import legacyImportDemo_3504264987 from "../../../../../packages/component/src/components/select/demo/demo5.js?loadDemo";
import legacyImportDemo_117395704 from "../../../../../packages/component/src/components/select/demo/demo6.js?loadDemo";
import legacyImportDemo_2995792473 from "../../../../../packages/component/src/components/select/demo/demo7.js?loadDemo";
import legacyImportDemo_2924974134 from "../../../../../packages/component/src/components/select/demo/demo8.js?loadDemo";
import legacyImportDemo_2449138472 from "../../../../../packages/component/src/components/select/demo/demo17.js?loadDemo";
import legacyImportDemo_2175484823 from "../../../../../packages/component/src/components/select/demo/demo9.js?loadDemo";
import legacyImportDemo_1884300399 from "../../../../../packages/component/src/components/select/demo/demo10.js?loadDemo";
import legacyImportDemo_1351993262 from "../../../../../packages/component/src/components/select/demo/demo11.js?loadDemo";
import legacyImportDemo_2073998829 from "../../../../../packages/component/src/components/select/demo/demo12.js?loadDemo";
import legacyImportDemo_130630188 from "../../../../../packages/component/src/components/select/demo/demo13.js?loadDemo";
import legacyImportDemo_3226311019 from "../../../../../packages/component/src/components/select/demo/demo14.js?loadDemo";
import legacyImportDemo_580641450 from "../../../../../packages/component/src/components/select/demo/demo15.js?loadDemo";
import legacyImportDemo_352239719 from "../../../../../packages/component/src/components/select/demo/demo18.js?loadDemo";
import legacyImportDemo_594191270 from "../../../../../packages/component/src/components/select/demo/demo19.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4291016863,
  legacyImportDemo_1914942076,
  legacyImportDemo_2656822749,
  legacyImportDemo_4122151657,
  legacyImportDemo_2899520442,
  legacyImportDemo_3504264987,
  legacyImportDemo_117395704,
  legacyImportDemo_2995792473,
  legacyImportDemo_2924974134,
  legacyImportDemo_2449138472,
  legacyImportDemo_2175484823,
  legacyImportDemo_1884300399,
  legacyImportDemo_1351993262,
  legacyImportDemo_2073998829,
  legacyImportDemo_130630188,
  legacyImportDemo_3226311019,
  legacyImportDemo_580641450,
  legacyImportDemo_352239719,
  legacyImportDemo_594191270,
  React
};